import { useCallback, useEffect, useState } from 'react';
const API = process.env.REACT_APP_BACKEND_URL;

export async function delegationRequest(path, options = {}) {
  const r = await fetch(`${API}/api/company/regional-delegation/${path}`, { credentials:'include', ...options });
  const data = await r.json();
  if (!r.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Unable to update regional delegation.');
  return data;
}

export function useRegionalDelegation() {
  const [data,setData] = useState(null), [error,setError] = useState(''), [loading,setLoading] = useState(true);
  const load = useCallback(async () => {
    try { const result = await delegationRequest('workspace'); setData(result); setError(''); return result; }
    catch(e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  },[]);
  useEffect(() => {
    const reload = () => load().catch(()=>{});
    reload(); window.addEventListener('focus',reload); window.addEventListener('regional-delegation-saved',reload);
    return () => { window.removeEventListener('focus',reload); window.removeEventListener('regional-delegation-saved',reload); };
  },[load]);
  return {data,error,loading,load};
}